import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MainLayout from './components/MainLayout';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#14B451',  // Cambiado a tu color verde
      light: '#4BCB7A', // Versión más clara (opcional)
      dark: '#0E8039',  // Versión más oscura (opcional)
      contrastText: '#fff' // Color del texto sobre este fondo
    },
    secondary: {
      main: '#dc004e', // Puedes mantener esto o cambiarlo también
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    // Personalizaciones adicionales de componentes (opcional)
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Opcional: evita que los textos de botones se conviertan en mayúsculas
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MainLayout />
    </ThemeProvider>
  </React.StrictMode>
);